// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/theme/css/dashboard.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashoard-card1 {
  height: 70%;
  max-height: 400px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}

.dashoard-card {
  height: 30%;
  max-height: 150px;
  padding: 0px;
  display: flex;
  flex-direction: column;
}

.card .card-title {
  position: relative;
  font-size: 16px !important;
}

.table > thead {
  vertical-align: bottom;
  background-color: #82a0ec;
  color: white !important;
}

.table thead tr th,
.table tbody tr td {
  position: relative;
  border: 1px solid #edf1f7;
  vertical-align: middle;
  padding: 0.6em 0.6rem;
  text-align: left;
}

.table thead tr th {
  font-weight: normal;
  font-size: 0.95rem;
  color: white;
}

.dashboard-table-body {
  padding-left: 10px;
  padding-right: 10px;
}

.quick-nav-scroll {
  max-height: 112px;
  overflow-y: auto;
}

.quick-nav-list {
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 0;
  display: flex;
  color: gray;
  flex-wrap: wrap;
}

.quick-nav-list li {
  width: 50%; /* Two items per row */
  margin-bottom: 0.5rem;
}

.quick-nav-link {
  color: grey;
  text-decoration: none;
}

.quick-nav-list :hover {
  color: #36f;
}

.quick-nav-link-title {
  font-size: 1.1rem !important;
  margin-bottom: -9px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/premium-over-due/premium-over-due.component.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,sBAAA;EACA,yBAAA;EACA,uBAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;AAAF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,UAAA,EAAA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,4BAAA;EACA,mBAAA;AACF","sourcesContent":["@import '../../../assets/theme/css/dashboard.css';\n\n.dashoard-card1 {\n  height: 70%;\n  max-height: 400px;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashoard-card {\n  height: 30%;\n  max-height: 150px;\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n}\n\n.card .card-title {\n  position: relative;\n  font-size: 16px !important;\n}\n\n.table > thead {\n  vertical-align: bottom;\n  background-color: #82a0ec;\n  color: white !important;\n}\n\n.table thead tr th,\n.table tbody tr td {\n  position: relative;\n  border: 1px solid #edf1f7;\n  vertical-align: middle;\n  padding: 0.6em 0.6rem;\n  text-align: left;\n}\n\n.table thead tr th {\n  font-weight: normal;\n  font-size: 0.95rem;\n  color: white;\n}\n.dashboard-table-body {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.quick-nav-scroll {\n  max-height: 112px;\n  overflow-y: auto;\n}\n\n.quick-nav-list {\n  list-style-type: disc;\n  padding-left: 20px;\n  margin-bottom: 0;\n  display: flex;\n  color: gray;\n  flex-wrap: wrap;\n}\n\n.quick-nav-list li {\n  width: 50%; /* Two items per row */\n  margin-bottom: 0.5rem;\n}\n\n.quick-nav-link {\n  color: grey;\n  text-decoration: none;\n}\n\n.quick-nav-list :hover {\n  color: #36f;\n}\n\n.quick-nav-link-title {\n  font-size: 1.1rem !important;\n  margin-bottom: -9px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
